import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'grid',
        maxWidth: '100%',
        gap: 15,
        rowGap: 30,
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns:'repeat(3, 1fr)',
        },
        [theme.breakpoints.between('sm','lg')]: {
            gridTemplateColumns:'repeat(2, 1fr)',
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns:'repeat(1, 1fr)',
        }
    },  
}));

export const InputContainer: React.FC = ({children}) => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            {children}
        </div>
    )
}